export const columns = [{
  title: 'Status',
  dataIndex: 'status',
  key: 'status',
  filters: [{
    text: 'Pending',
    value: 1
  }, {
    text: 'Matched',
    value: 2
  }, {
    text: 'Scoping',
    value: 3
  }, {
    text: 'Activated',
    value: 4
  }, {
    text: 'Completed',
    value: 5
  }, {
    text: 'Closed',
    value: 6
  }],
  filteredValue: [],
  sorter: true,
  sortOrder: false
}, {
  title: 'Project ID',
  dataIndex: 'projectId',
  key: 'projectId',
  sorter: true,
  sortOrder: false
}, {
  title: 'Project Name',
  dataIndex: 'projectName',
  key: 'projectName',
  sortOrder: false,
  sorter: true
}, {
  title: 'Partner',
  dataIndex: 'partner',
  key: 'partner',
  sortOrder: false,
  sorter: true
}, {
  title: 'Tags',
  dataIndex: 'tags',
  key: 'tags',
  width: 350
}, {
  title: 'Start Date',
  dataIndex: 'startDate',
  key: 'startDate',
  sortOrder: false,
  sorter: true
}, {
  title: 'End Date',
  dataIndex: 'endDate',
  key: 'endDate',
  sortOrder: false,
  sorter: true
}, {
  title: 'Created Date',
  dataIndex: 'createdDate',
  key: 'createdDate',
  sortOrder: false,
  sorter: true
}];
export const dataSource = [{
  key: 1,
  status: '1',
  projectId: {
    key: 1,
    value: 'PWM000001',
    status: '1'
  },
  client: {
    key: 2,
    value: 'Test Client'
  },
  partner: {
    value: '-'
  },
  createdDate: '11/05/2022',
  startdate: '-',
  endDate: '31/05/2022',
  projectName: {
    key: 1,
    value: 'Vagabond',
    status: '1'
  }
}];
export const pagination = {
  current: 1,
  pageSize: 10,
  total: 1,
  showSizeChanger: true,
  search: '',
  Sort: '-updated_date',
  source: 'standard'
};